import { useContext } from 'react';
import { CustomerBrandContext } from 'context/CustomerBrandContext';

const useCustomerBrandContext = () => {
  const ctx = useContext(CustomerBrandContext);
  return { ...ctx };
};

export default useCustomerBrandContext;
